import { createApi } from '@vgtv/api-client';
import ky from 'ky';
import type { Options } from 'ky';
import type { InsightsEvent } from 'search-insights';
import type { CnpAuthor } from '@vgtv/api-client/lib/cnp_authors';

import type { Vendor } from '../types';
import type { SearchComponent } from '../modules/search';
import { config } from '../config';
import { getAppCapabilitiesHeader } from '../shared/appCapabilities';

import { unleash } from './unleash';

const client = ky.create({
  prefixUrl: new URL(config.apiHostname).origin,
  retry: 3,
});

const api = {
  ...createApi(client, config.provider),
  search: {
    query: async (
      { query, vendor }: { query: string; vendor: Vendor },
      options?: Options
    ) => {
      const features: string[] = [];

      if (unleash.isEnabled('brandstudio')) {
        features.push('brandstudio');
      }

      return client
        .get(`${vendor}/search`, {
          searchParams: { q: query, features: features.join(',') },
          ...options,
          headers: {
            ...options?.headers,
            ...getAppCapabilitiesHeader(),
          },
        })
        .json<{ components: SearchComponent[] }>();
    },
    sendEvents: async (
      { events, vendor }: { events: InsightsEvent[]; vendor: Vendor },
      options?: Options
    ) => {
      return client.post(`${vendor}/search/events`, {
        json: { events },
        ...options,
      });
    },
  },
  getAuthors: async ({ ids, vendor }: { ids: string[]; vendor: string }) => {
    const authorsIds = ids.join(',');
    try {
      const response = await client
        .get(`${vendor}/authors?ids=${authorsIds}`, {})
        .json<{ authors: CnpAuthor[] }>();
      return response;
    } catch (error) {
      throw new Error('Failed to fetch authors');
    }
  },
};

export default api;
